module.exports = __webpack_public_path__ + "static/img/ptGame6.aff5333.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame6.webp
// module id = XtDL
// module chunks = 3